import React from "react";
import { Circles } from "react-loader-spinner";

const Loading = () => {
  return (
    <div className="h-screen flex justify-center items-center bg-black">
      <Circles
        height="100"
        width="100"
        color="#ffffff"
        ariaLabel="circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
};

export default Loading;
